export enum ProgressBarStep {
  CHOOSE_FANTASY_PROVIDER = 1,
  ENTER_DETAILS_FOR_FANTASY_PROVIDER = 2,
  CONFIRM_FANTASY_LEAGUE_TO_SYNC = 3,
}

export enum EspnProgressBarStep {
  CHOOSE_FANTASY_PROVIDER = 1,
  REDIRECT_TO_EXTENSION = 2,
  REDIRECT_TO_ESPN = 3,
  ENTER_DETAILS_FOR_FANTASY_PROVIDER = 4,
  CONFIRM_FANTASY_LEAGUE_TO_SYNC = 5,
}
export enum CTALocation {
  CREATE_FREE_ACCOUNT = 'Create Free Account',
  LEAGUE_SYNC_STEP_ONE = 'League Sync Step 1',
  LEAGUE_SYNC_STEP_TWO = 'League Sync Step 2',
  LEAGUE_SYNC_STEP_THREE = 'League Sync Step 3',
  DELETE_LEAGUE_MODEL = 'Delete League Modal',
  MY_LEAGUE = 'My Leagues',
}

export enum CTAName {
  GO_TO_MY_LEAGUE = 'Go To My Leagues',
  TRY_SYNC_AGAIN = 'Try Sync Again',
  START_LEAGUE_SYNC = 'Start League Sync',
  SYNC_LEAGUE = 'Sync League',
}

export const PROGRESS_BAR_STEP = ['1', '2', '3']
export const ESPN_PROGRESS_BAR_STEP = ['1', '2', '3', '4', '5']

export interface League {
  id: number
  name: string
  size: number
  auction_budget: number
  league_type: string
  season: number
  team_name: string
  hosted_site: string
  hosted_site_url: string
  keepers: number
  keeper_type: string
  draft_type: string
  draft_completed: boolean
  lineup_type: string
}

export interface Leagues {
  leagues: League[]
}
